const promotions = (state = {}) => state;

export default promotions;
